import React from 'react';

import LoadingScreen from '../LoadingScreen';

import { useOAuthServer } from './hooks/useOAuthServer';

export const OAuthCallback: React.FC = () => {
  useOAuthServer();

  return <LoadingScreen notifications={[]} />;
};
